
import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { MediaProvider } from "@/components/media/context";
import MediaFilter from "@/components/media/MediaFilter";
import MediaGallery from "@/components/media/MediaGallery";
import MediaModal from "@/components/media/MediaModal";
import EditModeToggle from "@/components/media/EditModeToggle";
import EditModeOverlay from "@/components/media/EditModeOverlay";
import EditMediaSheet from "@/components/media/EditMediaSheet";
import { useState } from "react";
import { MediaItemData } from "@/components/media/types/mediaTypes";

const MediaPage: React.FC = () => {
  const { t } = useLanguage();
  const [editingItem, setEditingItem] = useState<MediaItemData | null>(null);
  const [isEditSheetOpen, setIsEditSheetOpen] = useState(false);

  const handleEditItem = (item: MediaItemData) => {
    setEditingItem(item);
    setIsEditSheetOpen(true);
  };

  console.log("Rendering MediaPage component");

  return (
    <div className="min-h-screen">
      <Navbar />
      
      {/* Header */}
      <header className="pt-32 pb-12 bg-palsustain-beige/30">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-3xl md:text-5xl font-bold text-palsustain-green mb-4">
            {t("media.title")}
          </h1>
          <p className="text-lg md:text-xl text-palsustain-charcoal/80 max-w-3xl mx-auto">
            {t("media.subtitle")}
          </p>
        </div>
      </header>
      
      <MediaProvider>
        <div className="media-content">
          <EditModeOverlay />
          <MediaFilter />
          <MediaGallery />
          <MediaModal />
          <EditModeToggle />
        </div>
        <EditMediaSheet 
          isOpen={isEditSheetOpen}
          onOpenChange={setIsEditSheetOpen}
          editingItem={editingItem}
        />
      </MediaProvider>
      
      <Footer />
    </div>
  );
};

export default MediaPage;
